(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-share"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /**
   * cart-share
   * Barra de compartilhamento de carrinho + diálogo de confirmação.
   *
   * O link gerado é um cart permalink nativo do Shopify:
   *   /cart/{variant_id}:{quantity},{variant_id}:{quantity}?storefront=true
   *
   * Delegação de eventos no document — a barra vive no layout e nunca é
   * substituída pelo refresh do drawer ou da página de carrinho.
   */

  // Nome do atributo gravado no carrinho e exibido no pedido.
  // Fica fora das traduções de propósito: trocar de idioma não pode trocar a chave.
  var SELLER_ATTRIBUTE = 'Vendedor';
  var SELLER_STORAGE_KEY = 'cartShare:sellerCode';

  var i18n = {};
  var isReady = false;
  var lastFocused = null;
  var toastTimer = null;
  var closeTimer = null;
  var onConfirm = null;

  // ─── Auxiliares ────────────────────────────────────────────────────────────

  function $(selector) {
    return document.querySelector(selector);
  }

  function _loadI18n() {
    var el = $('[data-cart-share-i18n]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error('[CartShare] i18n inválido:', err);
      return {};
    }
  }

  function _storedSellerCode() {
    try {
      return localStorage.getItem(SELLER_STORAGE_KEY) || '';
    } catch (err) {
      return '';
    }
  }

  function _storeSellerCode(code) {
    try {
      if (code) {
        localStorage.setItem(SELLER_STORAGE_KEY, code);
      } else {
        localStorage.removeItem(SELLER_STORAGE_KEY);
      }
    } catch (err) {
      /* modo privado — segue apenas com o atributo do carrinho */
    }
  }

  async function _getCart() {
    var res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  }

  async function _updateCart(payload) {
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  }

  /** Monta o cart permalink a partir do estado atual do carrinho. */
  function _buildShareUrl(cart) {
    if (!cart || !cart.item_count) return '';

    var items = cart.items
      .map(function (item) { return item.variant_id + ':' + item.quantity; })
      .join(',');

    var params = new URLSearchParams();

    // Leva o destinatário para a página de carrinho em vez do checkout direto.
    params.set('storefront', 'true');

    var discounts = cart.cart_level_discount_applications || [];
    if (discounts.length && discounts[0].title) {
      params.set('discount', discounts[0].title);
    }

    // Código do vendedor viaja junto com o link para atribuir a venda.
    var seller = (cart.attributes && cart.attributes[SELLER_ATTRIBUTE]) || '';
    if (seller) {
      params.set('attributes[' + SELLER_ATTRIBUTE + ']', seller);
    }

    return window.location.origin + '/cart/' + items + '?' + params.toString();
  }

  async function _copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        /* segue para o fallback */
      }
    }

    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (err) {
      copied = false;
    }
    document.body.removeChild(textarea);
    return copied;
  }

  function _showToast(message) {
    var toast = $('[data-cart-share-toast]');
    if (!toast || !message) return;

    toast.textContent = message;
    toast.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /** Sincroniza drawer e página de carrinho após alterações programáticas. */
  function _notifyCartChanged() {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
  }

  // ─── Diálogo ───────────────────────────────────────────────────────────────

  function _openDialog(config) {
    var overlay = $('[data-cart-share-overlay]');
    if (!overlay) return;

    clearTimeout(closeTimer);

    var markSuccess = $('[data-cart-share-mark="success"]');
    var markQuery = $('[data-cart-share-mark="query"]');
    var title = $('[data-cart-share-title]');
    var text = $('[data-cart-share-text]');
    var code = $('[data-cart-share-code]');
    var url = $('[data-cart-share-url]');
    var field = $('[data-cart-share-field]');
    var input = $('[data-cart-share-input]');
    var confirmBtn = $('[data-cart-share-confirm]');
    var cancelBtn = $('[data-cart-share-cancel]');

    lastFocused = document.activeElement;
    onConfirm = config.onConfirm || null;

    markSuccess.hidden = config.mark !== 'success';
    markQuery.hidden = config.mark !== 'query';

    // Substitui o nó para reiniciar a animação do traço a cada abertura
    if (config.mark === 'success') {
      markSuccess.parentNode.replaceChild(markSuccess.cloneNode(true), markSuccess);
    }

    title.textContent = config.title || '';

    text.textContent = config.text || '';
    text.hidden = !config.text;

    url.textContent = config.url || '';
    code.hidden = !config.url;

    field.hidden = !config.input;
    if (config.input) {
      input.type = config.inputType || 'text';
      input.setAttribute('inputmode', config.inputMode || 'text');
      input.dataset.cartShareInputMode = config.inputMask || '';
      input.value = config.inputValue || '';
      input.placeholder = config.inputPlaceholder || '';
    } else {
      input.dataset.cartShareInputMode = '';
    }

    confirmBtn.textContent = config.confirmLabel || i18n.ok || 'OK';

    cancelBtn.hidden = !config.cancelLabel;
    cancelBtn.textContent = config.cancelLabel || '';

    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      if (config.input) {
        input.focus();
        input.select();
      } else {
        confirmBtn.focus();
      }
    });
  }

  function _closeDialog() {
    var overlay = $('[data-cart-share-overlay]');
    if (!overlay || overlay.hidden) return;

    overlay.classList.remove('is-visible');
    onConfirm = null;

    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      overlay.hidden = true;
    }, 200);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  // ─── Ações da barra ────────────────────────────────────────────────────────

  function _dialogEmptyCart() {
    _openDialog({
      mark: 'query',
      title: i18n.emptyTitle,
      text: i18n.emptyText,
      confirmLabel: i18n.ok
    });
  }

  function _normalizePhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.indexOf('00') === 0) digits = digits.slice(2);
    if (digits.length === 10 || digits.length === 11) digits = '55' + digits;
    if (digits.length < 12 || digits.length > 15) return '';
    return digits;
  }

  function _formatPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.indexOf('55') === 0 && digits.length > 11) digits = digits.slice(2);
    if (digits.length <= 2) return digits ? '(' + digits : '';
    if (digits.length <= 6) return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    if (digits.length <= 10) {
      return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 6) + '-' + digits.slice(6);
    }
    return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + '-' + digits.slice(7, 11);
  }

  async function _actionShare(mode) {
    var cart;
    try {
      cart = await _getCart();
    } catch (err) {
      console.error('[CartShare]', err);
      _showToast(i18n.genericError);
      return;
    }

    var shareUrl = _buildShareUrl(cart);
    if (!shareUrl) {
      _dialogEmptyCart();
      return;
    }

    if (mode === 'whatsapp') {
      _openDialog({
        mark: 'query',
        title: i18n.whatsappTitle,
        text: i18n.whatsappText,
        input: true,
        inputType: 'tel',
        inputMode: 'tel',
        inputMask: 'phone',
        inputValue: '',
        inputPlaceholder: i18n.whatsappPlaceholder,
        confirmLabel: i18n.ok,
        cancelLabel: i18n.cancel,
        onConfirm: function (phone) {
          var recipient = _normalizePhone(phone);
          if (!recipient) {
            _showToast(i18n.whatsappInvalid);
            return;
          }

          var message = (i18n.whatsappMessage || '') + ' ' + shareUrl;
          window.open('https://wa.me/' + recipient + '?text=' + encodeURIComponent(message.trim()), '_blank', 'noopener');
        }
      });
      return;
    }

    var copied = await _copyToClipboard(shareUrl);

    _openDialog({
      mark: 'success',
      title: i18n.successTitle,
      text: i18n.successText,
      url: shareUrl,
      confirmLabel: i18n.ok,
      cancelLabel: i18n.copy
    });

    if (copied) _showToast(i18n.copied);
  }

  async function _actionSellerCode() {
    var current = _storedSellerCode();

    try {
      var cart = await _getCart();
      var fromCart = cart.attributes && cart.attributes[SELLER_ATTRIBUTE];
      if (fromCart) current = fromCart;
    } catch (err) {
      /* mantém o valor local */
    }

    _openDialog({
      title: i18n.sellerTitle,
      text: i18n.sellerText,
      input: true,
      inputValue: current,
      inputPlaceholder: i18n.sellerPlaceholder,
      confirmLabel: i18n.save,
      cancelLabel: i18n.cancel,
      onConfirm: async function (code) {
        await _applySellerCode(code);
        _showToast(code ? i18n.sellerSaved : i18n.sellerRemoved);
      }
    });
  }

  async function _applySellerCode(code) {
    var attributes = {};
    attributes[SELLER_ATTRIBUTE] = code || '';

    try {
      await _updateCart({ attributes: attributes });
      _storeSellerCode(code);
    } catch (err) {
      console.error('[CartShare]', err);
      _showToast(i18n.genericError);
    }
  }

  /**
   * Aplica o código do vendedor recebido pelo link compartilhado.
   * O permalink entrega o valor como `attributes[...]` na URL de destino.
   */
  async function _consumeSellerCodeFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var key = 'attributes[' + SELLER_ATTRIBUTE + ']';
    var code = params.get(key);
    if (!code) return;

    await _applySellerCode(code.trim());

    params.delete(key);
    var query = params.toString();
    window.history.replaceState(
      {},
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  // ─── Ligação de eventos ────────────────────────────────────────────────────

  function _bind() {
    document.addEventListener('click', async function (event) {
      // Gatilhos da barra
      var trigger = event.target.closest('[data-cart-share-action]');
      if (trigger) {
        event.preventDefault();
        switch (trigger.dataset.cartShareAction) {
          case 'seller-code':
            _actionSellerCode();
            break;
          case 'whatsapp':
            _actionShare('whatsapp');
            break;
          case 'link':
            _actionShare('link');
            break;
        }
        return;
      }

      // Confirmar
      if (event.target.closest('[data-cart-share-confirm]')) {
        var callback = onConfirm;
        var value = ($('[data-cart-share-input]').value || '').trim();
        _closeDialog();
        if (callback) await callback(value);
        return;
      }

      if (event.target.matches('[data-cart-share-input]') && event.target.dataset.cartShareInputMode === 'phone') {
        event.target.value = _formatPhone(event.target.value);
      }

      // Secundário — copia o link quando o diálogo mostra um link gerado
      if (event.target.closest('[data-cart-share-cancel]')) {
        var codeBox = $('[data-cart-share-code]');
        if (codeBox && !codeBox.hidden) {
          var copied = await _copyToClipboard($('[data-cart-share-url]').textContent);
          _showToast(copied ? i18n.copied : i18n.copyFailed);
        } else {
          _closeDialog();
        }
        return;
      }

      // Fechar
      if (event.target.closest('[data-cart-share-close]')) {
        _closeDialog();
        return;
      }
      if (event.target.matches('[data-cart-share-overlay]')) {
        _closeDialog();
        return;
      }

      // Seleciona o link inteiro ao clicar
      var selectable = event.target.closest('[data-cart-share-code]');
      if (selectable) {
        var range = document.createRange();
        range.selectNodeContents(selectable);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });

    document.addEventListener('keydown', function (event) {
      var overlay = $('[data-cart-share-overlay]');
      if (!overlay || overlay.hidden) return;

      if (event.key === 'Escape') {
        _closeDialog();
        return;
      }

      if (event.key === 'Enter' && event.target.matches('[data-cart-share-input]')) {
        event.preventDefault();
        $('[data-cart-share-confirm]').click();
      }
    });
  }

  // ─── Inicialização ─────────────────────────────────────────────────────────

  function init() {
    if (isReady || !$('[data-cart-share]')) return;
    isReady = true;

    i18n = _loadI18n();
    _bind();
    _consumeSellerCodeFromUrl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindLocalSearch = () => {
      document.querySelectorAll('[data-collection-local-search]').forEach(wrapper => {
        if (wrapper.dataset.searchBound === 'true') return;
        wrapper.dataset.searchBound = 'true';

        const toggle = wrapper.querySelector('[data-collection-local-search-toggle]');
        const field = wrapper.querySelector('[data-collection-local-search-field]');
        const input = wrapper.querySelector('[data-collection-local-search-input]');
        const close = wrapper.querySelector('[data-collection-local-search-close]');
        const bar = wrapper.closest('.collectionFilters');
        if (!toggle || !field || !input || !close || !bar) return;

        const openSearch = () => {
          wrapper.classList.add('is-open');
          bar.classList.add('is-search-open');
          field.hidden = false;
          toggle.hidden = true;
          toggle.setAttribute('aria-expanded', 'true');
          input.focus({ preventScroll: true });
        };

        const closeSearch = ({ restoreFocus = false } = {}) => {
          if (input.value) {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
          input.blur();
          field.hidden = true;
          toggle.hidden = false;
          wrapper.classList.remove('is-open');
          bar.classList.remove('is-search-open');
          toggle.setAttribute('aria-expanded', 'false');
          if (restoreFocus) toggle.focus({ preventScroll: true });
        };

        toggle.addEventListener('click', event => {
          event.preventDefault();
          openSearch();
        });

        close.addEventListener('click', event => {
          event.preventDefault();
          closeSearch({ restoreFocus: true });
        });

        wrapper.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !wrapper.classList.contains('is-open')) return;
          event.preventDefault();
          event.stopPropagation();
          closeSearch({ restoreFocus: true });
        });
      });
    };
    const bindKeyboardAwareCollectionActions = () => {
      document.querySelectorAll('.collectionFilters[data-results-context="collection"]').forEach((filtersBar) => {
        const actions = filtersBar.querySelector('.collectionFilters__actions');
        if (!actions || actions.dataset.keyboardAwareBound === 'true') return;
        actions.dataset.keyboardAwareBound = 'true';

        const updateKeyboardOffset = () => {
          if (!window.matchMedia('(max-width: 749px)').matches || !window.visualViewport) {
            actions.style.setProperty('--collection-keyboard-offset', '0px');
            return;
          }

          const vv = window.visualViewport;
          const hiddenBottom = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
          const isKeyboardOpen = hiddenBottom > 80;
          actions.style.setProperty('--collection-keyboard-offset', isKeyboardOpen ? `${hiddenBottom}px` : '0px');
        };

        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', updateKeyboardOffset, { passive: true });
          window.visualViewport.addEventListener('scroll', updateKeyboardOffset, { passive: true });
        }
        window.addEventListener('orientationchange', updateKeyboardOffset, { passive: true });
        updateKeyboardOffset();
      });
    };

    const bindToolbarMotionOnce = () => {
      const storageKey = 'ioraneCollectionToolbarInteracted';

      document.querySelectorAll('.collectionFilters[data-results-context="collection"]').forEach((filtersBar) => {
        const actions = filtersBar.querySelector('.collectionFilters__actions');
        if (!actions || actions.dataset.motionOnceBound === 'true') return;

        actions.dataset.motionOnceBound = 'true';

        try {
          if (window.localStorage.getItem(storageKey) === '1') {
            filtersBar.classList.add('has-toolbar-interacted');
            return;
          }
        } catch (error) {}

        const stopMotion = () => {
          filtersBar.classList.add('has-toolbar-interacted');
          try {
            window.localStorage.setItem(storageKey, '1');
          } catch (error) {}
        };

        actions.addEventListener('pointerdown', stopMotion, { once: true, passive: true });
        actions.addEventListener('keydown', stopMotion, { once: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => { bindKeyboardAwareCollectionActions(); bindLocalSearch(); bindToolbarMotionOnce(); }, { once: true });
    } else {
      bindKeyboardAwareCollectionActions();
      bindLocalSearch();
      bindToolbarMotionOnce();
    }

    document.addEventListener('shopify:section:load', () => { bindKeyboardAwareCollectionActions(); bindLocalSearch(); bindToolbarMotionOnce(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-media"] && !Shopify.designMode) return;
  try {
    if (!window.__ioraneCollectionMediaCart) {
    window.__ioraneCollectionMediaCart = true;

    document.addEventListener('click', async (event) => {
      const addButton = event.target.closest('[data-collection-media-add]');

      if (!addButton || addButton.disabled) return;

      event.preventDefault();

      const variantId = addButton.dataset.variantId;

      if (!variantId || !window.CartManager?.add) return;

      await window.CartManager.add(variantId, {
        button: addButton,
        action: 'open_drawer',
        variantPrice: addButton.dataset.variantPrice,
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-menu-model-2"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncNewInViewport = (details) => {
      const panels = [...details.querySelectorAll('.headerModel2Header__panelInner--new-in, .headerModel2Header__panelInner--design:not(.headerModel2Header__panelInner--special-edition)')];
      if (!panels.length || !details.open) return;
      panels.forEach((panel) => {
      const panelFrame = panel.closest('.headerModel2Header__panel') || panel;
      const top = Math.max(0, Math.ceil(panelFrame.getBoundingClientRect().top));
      const panelStyles = window.getComputedStyle(panel);
      const verticalPadding = (parseFloat(panelStyles.paddingTop) || 0)
        + (parseFloat(panelStyles.paddingBottom) || 0);
      const availableMediaHeight = Math.max(140, Math.min(
        740,
        window.innerHeight - top - verticalPadding - 60
      ));
      // Dimensiona somente a vitrine pelo espaco vertical da janela;
      // o layout inteiro continua encostado nas margens laterais.
      const panelWidth = Math.max(1, panel.clientWidth
        - (parseFloat(panelStyles.paddingLeft) || 0)
        - (parseFloat(panelStyles.paddingRight) || 0));
      const navReserve = Math.min(320, Math.max(220, panelWidth * .29));
      const panelGap = Math.min(50, Math.max(24, window.innerWidth * .03));
      const photoGap = 5;
      const threeCardSpace = Math.floor((panelWidth - navReserve - panelGap - 2 * photoGap) / 3);
      const cardWidth = Math.max(92, Math.min(155, Math.floor(availableMediaHeight * .42), threeCardSpace));
      panel.style.setProperty('--new-in-panel-top', `${top}px`);
      panel.style.setProperty('--mega-card-width', `${cardWidth}px`);
      });
    };

    const bindHoverMenus = () => {
      const canHover = window.matchMedia('(hover: hover) and (min-width: 1280px)');
      document.querySelectorAll('[data-nxt-brand-landing]').forEach(link => {
        if (link.dataset.nxtNavigationBound === 'true') return;
        link.dataset.nxtNavigationBound = 'true';
        link.addEventListener('click', event => event.stopPropagation());
      });

      document.querySelectorAll('[data-header-menu-model-2]').forEach((root) => {
        const detailsItems = [...root.querySelectorAll('details')];

        if (root.dataset.newInViewportBound !== 'true') {
          root.dataset.newInViewportBound = 'true';
          window.addEventListener('resize', () => {
            detailsItems.forEach((details) => {
              if (details.open) syncNewInViewport(details);
            });
          }, { passive: true });
        }

        detailsItems.forEach((details) => {
          if (details.dataset.hoverBound === 'true') return;

          details.dataset.hoverBound = 'true';
          const rootSummary = details.querySelector(':scope > summary[data-desktop-root-link]');
          if (rootSummary) {
            rootSummary.addEventListener('click', (event) => {
              if (!canHover.matches || event.detail === 0) return;
              event.preventDefault();
              window.location.assign(rootSummary.dataset.desktopRootLink);
            });
          }
          details.addEventListener('toggle', () => {
            if (details.open) window.requestAnimationFrame(() => syncNewInViewport(details));
          });
          details.addEventListener('pointerenter', () => {
            if (!canHover.matches) return;

            window.clearTimeout(details.hoverCloseTimer);
            detailsItems.forEach((otherDetails) => {
              if (otherDetails !== details) {
                window.clearTimeout(otherDetails.hoverCloseTimer);
                otherDetails.classList.remove('is-active');
                otherDetails.open = false;
              }
            });

            details.classList.remove('is-active');
            details.open = false;
            void details.offsetWidth;
            details.classList.add('is-active');
            details.open = true;
            window.requestAnimationFrame(() => syncNewInViewport(details));
          });
          details.addEventListener('pointerleave', () => {
            if (!canHover.matches) return;

            window.clearTimeout(details.hoverCloseTimer);
            details.hoverCloseTimer = window.setTimeout(() => {
              if (!details.matches(':hover')) {
                details.classList.remove('is-active');
                details.open = false;
              }
            }, 180);
          });
        });
      });
    };

    const bindHeaderSearch = () => {
      document.querySelectorAll('[data-header-menu-model-2]').forEach((root) => {
        if (root.dataset.headerSearchBound === 'true') return;
        root.dataset.headerSearchBound = 'true';

        const desktopWrapper = root.querySelector('[data-search-wrapper]');
        const desktopToggle = root.querySelector('[data-header-model2-search-toggle]');
        const desktopPanel = root.querySelector('[data-header-model2-search-panel]');
        const desktopInput = desktopPanel?.querySelector('[data-header-search-input]');
        const desktopClose = desktopPanel?.querySelector('[data-header-search-close]');

        const mobileToggle = root.querySelector('[data-header-model2-mobile-search-toggle]');
        const mobilePanel = root.querySelector('[data-header-model2-mobile-search-panel]');
        const mobileInput = mobilePanel?.querySelector('[data-header-model2-mobile-search-input]');
        const mobileClose = mobilePanel?.querySelector('[data-header-model2-mobile-search-close]');

        const closeDesktop = ({ restoreFocus = false } = {}) => {
          if (!desktopWrapper || !desktopPanel || !desktopToggle) return;
          desktopPanel.hidden = true;
          desktopWrapper.classList.remove('is-open');
          desktopToggle.setAttribute('aria-expanded', 'false');
          desktopInput?.blur();
          if (restoreFocus) desktopToggle.focus({ preventScroll: true });
        };

        const openDesktop = () => {
          if (!desktopWrapper || !desktopPanel || !desktopToggle || !desktopInput) return;
          closeMobile();
          desktopPanel.hidden = false;
          desktopWrapper.classList.add('is-open');
          desktopToggle.setAttribute('aria-expanded', 'true');
          desktopInput.focus({ preventScroll: true });
          const end = desktopInput.value.length;
          desktopInput.setSelectionRange?.(end, end);
        };

        const closeMobile = ({ restoreFocus = false } = {}) => {
          if (!mobilePanel || !mobileToggle) return;
          mobilePanel.hidden = true;
          root.classList.remove('is-mobile-search-open');
          mobileToggle.setAttribute('aria-expanded', 'false');
          mobileInput?.blur();
          if (restoreFocus) mobileToggle.focus({ preventScroll: true });
        };

        const openMobile = () => {
          if (!mobilePanel || !mobileToggle || !mobileInput) return;
          closeDesktop();
          mobilePanel.hidden = false;
          root.classList.add('is-mobile-search-open');
          mobileToggle.setAttribute('aria-expanded', 'true');
          mobileInput.focus({ preventScroll: true });
          const end = mobileInput.value.length;
          mobileInput.setSelectionRange?.(end, end);
        };

        desktopToggle?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (desktopPanel?.hidden) openDesktop();
          else closeDesktop({ restoreFocus: true });
        });

        desktopClose?.addEventListener('click', (event) => {
          event.preventDefault();
          closeDesktop({ restoreFocus: true });
        });

        mobileToggle?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (mobilePanel?.hidden) openMobile();
          else closeMobile({ restoreFocus: true });
        });

        mobileClose?.addEventListener('click', (event) => {
          event.preventDefault();
          closeMobile({ restoreFocus: true });
        });

        document.addEventListener('click', (event) => {
          if (desktopWrapper && !desktopWrapper.contains(event.target)) closeDesktop();
          if (mobilePanel && mobileToggle && !mobilePanel.contains(event.target) && !mobileToggle.contains(event.target)) closeMobile();
        });

        root.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          if (desktopPanel && !desktopPanel.hidden) {
            event.preventDefault();
            closeDesktop({ restoreFocus: true });
          } else if (mobilePanel && !mobilePanel.hidden) {
            event.preventDefault();
            closeMobile({ restoreFocus: true });
          }
        });
      });
    };

    const bindHeaderInteractions = () => {
      bindHoverMenus();
      bindHeaderSearch();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindHeaderInteractions, { once: true });
    } else {
      bindHeaderInteractions();
    }

    document.addEventListener('shopify:section:load', bindHeaderInteractions);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-strip"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-iorane-promo-copy]');
    if (!button) return;

    var coupon = button.getAttribute('data-iorane-promo-copy');
    var defaultLabel = button.getAttribute('data-label-default') || button.textContent;
    var copiedLabel = button.getAttribute('data-label-copied') || defaultLabel;

    var confirmCopy = function () {
      button.textContent = copiedLabel;
      window.setTimeout(function () {
        button.textContent = defaultLabel;
      }, 1600);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(coupon).then(confirmCopy).catch(confirmCopy);
    } else {
      confirmCopy();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
